'use strict';

var actionBacklogStreamEventTypes = {
    backlogStateUpdate: 'backlog.state.update',
    backlogEmpty: 'backlog.empty'
};

module.exports = actionBacklogStreamEventTypes;